import styled from 'styled-components';

export const FlexContainer = styled.div`
  display: flex;
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.NL0};
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  position: relative;
  padding: 8px 16px;
  flex: 1;
`;

export const ImageWrapper = styled.div<{ height?: string }>`
  width: 100%;
  height: ${({ height }) => (height ? height : '100%')};
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TitleWrapper = styled.div`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  max-width: 100%;

  & a {
    color: ${({ theme }) => theme.palette.D400} !important;
  }
`;

export const Footer = styled.div`
  display: flex;
  gap: 10px;
  position: absolute;
  bottom: 8px;
  width: calc(100% - 32px);
  height: 43px;
  justify-content: end;
  align-items: center;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    align-items: center;
    gap: 12px;
  }
`;

export const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  white-space: nowrap;
  gap: 2px;
  & div {
    font-size: 20px;
    font-weight: 700;
    color: ${({ theme }) => theme.palette.D400};
  }
  & span {
    font-size: 12px;
    font-weight: 300;
    color: ${({ theme }) => theme.palette.D100};
    bottom: -5px;
    position: relative;
  }
`;

export const Line = styled.div`
  width: 6px;
  height: 43px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.palette.R600};
`;

export const DiscountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const FavoriteWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.white};
  width: 40px;
  height: 40px !important;
  z-index: 10;
  border-radius: 24px;
  padding-bottom: 3px;
`;
export const PriceText = styled.div`
  font-weight: 400 !important;
  font-size: 12px !important;
  color: ${({ theme }) => theme.palette.D300} !important;
  display: grid;
`;
